import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Admin from "./components/admin";
import Customer from "./components/customer";
import Profile from "./components/profile";
import Brand from "./components/brand";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AdminDashboard from "./components/admindashbord";
import StockList from "./components/stock";
import Cart from "./components/cart";
import Item from "./components/item";
import React, { useEffect } from "react";

import Slide from "./components/slide";
import Mainjewel from "./components/mainjewel";
import Sidebar from "./components/sidenav";
import Toast from "./components/demo";
import AddToCart from "./components/addCart";
import AddCartDetails from "./components/addCart";
import TextLinkExample from "./components/jewelNavbar";
import BrandLogo from "./components/brandLogo";
import ProductGrid from "./components/jewelNavbar";
import CartFilter from "./components/CartFilter";
import ThankYouBubble from "./components/Thankyou";
import { CartProvider } from "./components/CartContext";
import SlideBar from "./components/sidebar";
import FilteredDataDisplay from "./components/filter";
import SlideOne from "./components/filter";
import SlideTwo from "./components/slideone";
import CreateCustomer from "./components/CreateCustomer";
import OrderEntryForm from "./components/orderEntryForm";
import OrderFormPrint from "./components/orderFormPrint";
import TotalOrderSummary from "./components/totalOrderSummary";

import "./App.css";
import { Toaster } from "react-hot-toast";
import AdminLayout from "./components/common/AdminLayout";
import { GetCompanyDetails } from "./APICalls";
import TotalCustomers from "./components/TotalCustomers";
import Slidedup from "./components/slidedup";

function App() {

    const fetchCompanyDetails = async () => {
      const data = await GetCompanyDetails();
  
      if (data.error) {
        console.log("Failed to Fetch Company Details");
        return;
      }
      if (data.name) {
        document.title = data.name
      }
      if (data.logo) {
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = data.logo;
        document.head.appendChild(link);
      }
  
  
    };

    useEffect(()=> {
      fetchCompanyDetails()
    },[])


  return (
    <div className="App">
      {/* <Sidebar/> */}
      {/* <ProductGrid/> */}

      <div>
        <Toaster position="top-center" reverseOrder={false} />
      </div>

      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={ <AdminLayout pageName={"login"} >  <Admin /> </AdminLayout> } />
          <Route path="/" element={<Customer />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/brand" element={<Brand />} />
          <Route path="/admin-dashboard" element={ <AdminLayout> <AdminDashboard /> </AdminLayout> } />
          <Route path="/stock-list" element={<StockList />} />
          <Route path="/addtocartsummary" element={ <AdminLayout><Cart />   </AdminLayout> } />
          <Route path="/item" element={<Item />} />
          {/* <Route path="/mydesigns" element={<Slide />} /> */}
          <Route path="/mydesigns" element={<Slidedup />} />

          {/* <Route path=''/> */}
          <Route path="/customer-items/:id" element={<Mainjewel />} />
          <Route path="/add-to-cartDetails" element={<AddCartDetails />} />
          <Route path="/thankyou" element={<ThankYouBubble />} />
          <Route  path="/createCustomer" 
             element={ <AdminLayout pageName={'Create Customer'} > <CreateCustomer pageType={'create'} /> </AdminLayout>  } />
             <Route  path="/editCustomer" 
             element={ <AdminLayout pageName={'Edit Customer'} > <CreateCustomer pageType={'edit'} /> </AdminLayout>  } />
             
             
          <Route path="/orderentryform" element= { <AdminLayout pageName={'ORDER ENTRY FORM'} > <OrderEntryForm /> </AdminLayout> } />
          <Route path="/orderformprint" element={ <AdminLayout pageName={'ORDER FORM PRINT'} ><OrderFormPrint /> </AdminLayout> } />
          <Route path="/totalorderssummary" element={ <AdminLayout pageName={'TOTAL ORDERS SUMMARY'} >  <TotalOrderSummary /> </AdminLayout>} />
          <Route path="/total-customers" element={ <AdminLayout pageName={'TOTAL CUSTOMERS'} >  <TotalCustomers /> </AdminLayout>} />

        </Routes>
      </BrowserRouter>

      {/* <FilteredDataDisplay/> */}
    </div>
  );
}
export default App;
